import { Component } from 'vue-property-decorator';

Component.registerHooks(['beforeRouteUpdate', 'beforeRouteEnter']);
